module.exports = __webpack_public_path__ + "img/img_zhutu.1450a499.png";